import React from "react";
import "./commonComponents.scss";

function ToggleDisplayModal(props) {
  const {
    content,
    white = false,
    fitContent,
    noBgNoBorder = false,
    smallZIndex = false,
    noZIndex = false,
  } = props;
  return (
    <div
      className={`toggleModal${!noZIndex ? " defaultZIndex" : ""}${
        fitContent ? " fitCont" : ""
      }${noBgNoBorder ? " noBgNoBorder" : ""}${smallZIndex ? " smallZ" : ""}`}
      id="data-modal-dashboard"
      style={white ? { backgroundColor: "white" } : {}}
    >
      {content}
    </div>
  );
}

export default ToggleDisplayModal;
